import { SWRConfiguration } from 'swr'
import { useSWR } from './useSwr'
import { useGraphUrl } from './useGraphUrl'
import { fetcherGraph } from '../utils/fetcherGraph'

export function useGraphSWR<Data>(
  query: string | null | undefined,
  config?: SWRConfiguration<Data, Error>,
) {
  const url = useGraphUrl()
  return useSWR<Data>(
    query ? `${url}-${query}` : null,
    () => fetcherGraph<Data>(url, query!),
    config,
  )
}
